import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Image, Star, Trophy, MessageSquare, Settings, LogOut, ArrowLeft, Globe, Bot, Video, ClipboardList } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface AdminSidebarProps {
  onSignOut: () => void;
}

const links = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/admin/orders', icon: ClipboardList, label: 'Zakázky' },
  { to: '/admin/gallery', icon: Image, label: 'Galerie' },
  { to: '/admin/video-gallery', icon: Video, label: 'Video galerie' },
  { to: '/admin/testimonials', icon: Star, label: 'Reference' },
  { to: '/admin/wall-of-fame', icon: Trophy, label: 'Wall of Fame' },
  { to: '/admin/messages', icon: MessageSquare, label: 'Zprávy' },
  { to: '/admin/chatbot-leads', icon: Bot, label: 'Chatbot leady' },
  { to: '/admin/map', icon: Globe, label: 'Mapa' },
  { to: '/admin/settings', icon: Settings, label: 'Nastavení' },
];

const AdminSidebar = ({ onSignOut }: AdminSidebarProps) => {
  return (
    <aside className="w-64 min-h-screen bg-card border-r border-border flex flex-col">
      <div className="p-6 border-b border-border">
        <h2 className="text-2xl tracking-wider text-foreground" style={{ fontFamily: 'Bebas Neue' }}>
          Tom Art Mask
        </h2>
        <p className="text-xs text-muted-foreground">Admin Panel</p>
      </div>
      <nav className="flex-1 p-4 space-y-1">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                isActive
                  ? 'bg-primary/10 text-primary font-medium'
                  : 'text-muted-foreground hover:text-foreground hover:bg-secondary/50'
              }`
            }
          >
            <link.icon size={18} />
            {link.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-border space-y-2">
        <a href="/" className="flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft size={18} />
          Zpět na web
        </a>
        <Button variant="ghost" className="w-full justify-start gap-2 text-muted-foreground hover:text-destructive" onClick={onSignOut}>
          <LogOut size={18} />
          Odhlásit se
        </Button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
